/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A template folder that is auto-generated for every new claim in a company. Supports nesting via parentId.
 * @export
 * @interface DocumentFolderTemplate
 */
export interface DocumentFolderTemplate {
    /**
     * 
     * @type {number}
     * @memberof DocumentFolderTemplate
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentFolderTemplate
     */
    companyId: number;
    /**
     * Parent template ID. Null means root-level.
     * @type {number}
     * @memberof DocumentFolderTemplate
     */
    parentId?: number | null;
    /**
     * Folder template name
     * @type {string}
     * @memberof DocumentFolderTemplate
     */
    name: string;
    /**
     * Optional hex color code (e.g. #3B82F6)
     * @type {string}
     * @memberof DocumentFolderTemplate
     */
    color?: string | null;
    /**
     * Inactive templates are skipped during auto-generation
     * @type {boolean}
     * @memberof DocumentFolderTemplate
     */
    isActive: boolean;
    /**
     * 
     * @type {number}
     * @memberof DocumentFolderTemplate
     */
    createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof DocumentFolderTemplate
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof DocumentFolderTemplate
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the DocumentFolderTemplate interface.
 */
export function instanceOfDocumentFolderTemplate(value: object): value is DocumentFolderTemplate {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function DocumentFolderTemplateFromJSON(json: any): DocumentFolderTemplate {
    return DocumentFolderTemplateFromJSONTyped(json, false);
}

export function DocumentFolderTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentFolderTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'name': json['name'],
        'color': json['color'] == null ? undefined : json['color'],
        'isActive': json['isActive'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function DocumentFolderTemplateToJSON(json: any): DocumentFolderTemplate {
    return DocumentFolderTemplateToJSONTyped(json, false);
}

export function DocumentFolderTemplateToJSONTyped(value?: Omit<DocumentFolderTemplate, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'parentId': value['parentId'],
        'name': value['name'],
        'color': value['color'],
        'isActive': value['isActive'],
        'createdBy': value['createdBy'],
    };
}

